import React from 'react';
import { Marker, OverlayView } from '@react-google-maps/api';

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: 0,
});

const MarkerWithLabel = ({ label, labelStyle, ...props }) => {
  return (
    <Marker {...props}>
      <OverlayView
        key="mwl"
        position={props.position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={getPixelPositionOffset}
      >
        <div style={labelStyle}>{label}</div>
      </OverlayView>
    </Marker>
  );
};

export default MarkerWithLabel;
